export enum ApiRequestKey {
    PREPARE_AZTEC_SESSION = 'PREPARE_AZTEC_SESSION', // decodes aztec code to calculation/registration data, creates session with the decoded data
    DECODE_AZTEC = 'DECODE_AZTEC', // decodes aztec code to calculation/registration data
    POST_CALCULATION = 'POST_CALCULATION',
    PREPARE_REGISTRATION = 'PREPARE_REGISTRATION',
    OFFER_MODIFICATIONS = 'OFFER_MODIFICATIONS', // TODO verify for Uniqa when available
    POST_REGISTRATION = 'POST_REGISTRATION',
    NOTIFICATION = 'NOTIFICATION',
    DRAFT_OFFER = 'DRAFT_OFFER',
}
